module.exports = require("core-js-pure/features/instance/map");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/instance/map.js
// module id = 478
// module chunks = 13